/**
 * Provide the WebSite´s {@link Organization | publisher}. This is used, for example, in the imprint or in the
 * general terms.
 *
 * @module
 * @format
 *
 * @see [../html/hook/imprint.html]
 */

import {service} from 'nova';
import {parseScriptElementAsJson} from '@acng/frontend-bounty/parse.js';
import {assign} from '@acng/frontend-bounty/object.js';
import {t} from './locale/config/translate.js';
import {guard, asPublisher} from 'acng/model';

@service
class Publisher {
  constructor() {
    const data = parseScriptElementAsJson('publisher');

    ASSERT: {
      guard(data, asPublisher, '<webpage publisher data>');

      /**
       * @example CommunityPlanet B.V.
       */
      this.name = data.name;

      /**
       * @example CommunityPlanet
       */
      this.alternateName = data.alternateName;

      /**
       * @example +31 77 2061340
       */
      this.telephone = data.telephone;

      /**
       * @example +31 77 2061029
       */
      this.faxNumber = data.faxNumber;

      /**
       * @example https://www.communityplanet.eu/
       */
      this.url = data.url;

      /**
       * @example Info@communityplanet.eu
       */
      this.email = data.email;

      /**
       * @example John Cuppen
       */
      this.legalRepresentative = data.legalRepresentative;

      this.companyRegistration = data.companyRegistration;

      /**
       * @example NL818071953B02
       */
      this.vatID = data.vatID;
    }

    assign(this, data);

    this.address = {
      /**
       * @example Stationsplein 91
       */
      streetAddress: data.address.streetAddress,

      /**
       * @example 5211 BM
       */
      postalCode: data.address.postalCode,

      /**
       * @example 's-Hertogenbosch
       */
      addressLocality: data.address.addressLocality,

      /**
       * @example Netherlands
       */
      get addressCountry() {
        return t(`countries.iso.${data.address.addressCountry}`);
      },
    };
  }
}

export {Publisher};
